import React, {useEffect} from 'react';

export function useOnClickOutside(ref: React.MutableRefObject<HTMLElement | null>, handler: () => void): void {
    useEffect(() => {
        const listener = (event: Event | TouchEvent): void => {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target as Node | null)) {
                return;
            }

            const portal = document.querySelector('#portalContainerMain');

            if (portal && portal.contains(event.target as Node)) {
                return;
            }

            handler();
        };

        document.addEventListener('mouseup', listener);
        document.addEventListener('touchend', listener);

        return () => {
            document.removeEventListener('mouseup', listener);
            document.removeEventListener('touchend', listener);
        };
    }, [ref, handler]);
}
